import React from 'react';

import styles from './WarningMessage.css';

const WarningMessage = props => (
  <div>
    <div
      className={`alert ${styles['alert-orange']} ${props.addPadding}`}
      role="alert"
    >
      {props.message ? (
        <div>
          <img
            src={require(`./warning-icon${
              props.iconStyle ? `-${props.iconStyle}` : ''
            }.png`)}
            className={`${styles['warning-icon']}`}
          />
          <div>{props.message}</div>
        </div>
      ) : (
        <div>
          <img
            src={require(`./warning-icon${
              props.iconStyle ? `-${props.iconStyle}` : ''
            }.png`)}
          />
          {props.children}
        </div>
      )}
    </div>
  </div>
);

export default WarningMessage;
